import {useEffect, useRef, type FC} from "react"
import {Box, Stack} from "@mui/material"
import Pagination from "../../../components/atoms/pagination/Pagination"

type Props = {
  handleHotspotClick: (content: {
    index: number
    top: string
    left: string
    state: boolean
    active: boolean
    caseStudies: any[]
  }) => void
  boxPosition: any
  boxContent: any
  handlePageChange: (page: number) => void
  currentPage: number
}

const CaseStudyCardInfo: FC<Props> = (props) => {
  const contentRef = useRef<HTMLDivElement>(null)
  const divContentRef = useRef<HTMLDivElement>(null)
  const titleRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.innerHTML = props.boxContent[props.currentPage].content
    }
    if (titleRef.current) {
      titleRef.current.innerHTML = props.boxContent[props.currentPage].title
    }
  }, [titleRef, contentRef, props])

  useEffect(() => {
    divContentRef.current?.scrollTo(0, 0)
  }, [props.boxContent, props.boxPosition, contentRef, props.currentPage])

  return (
    <Box
      style={{
        position: "absolute",
        color: "#fff",
        textAlign: "center",
        width: "465px",
        display: "flex",
        flexDirection: "column",
        borderRadius: "8px",
        backgroundColor: "#fff",
        zIndex: 3,
        boxShadow:
          "0 0 2px 0 rgba(0, 0, 0, 0.12), 0 4px 8px 0 rgba(0, 0, 0, 0.14)",
        ...props.boxPosition,
      }}
    >
      <Box
        sx={{
          backgroundColor: "#ba0e68",
          height: "8px",
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
        }}
      ></Box>
      <Box>
        <Stack direction="row" gap="2">
          <Box
            sx={{
              width: "65%",
            }}
          >
            <Box
              sx={{
                fontSize: "20px",
                fontWeight: "600",
                color: "#000",
                padding: "16px 0px 16px 24px",
                textAlign: "start",
                "& h2": {
                  fontSize: "20px",
                  fontWeight: "600",
                },
                "& h3": {
                  fontSize: "20px",
                  fontWeight: "600",
                },
              }}
              ref={titleRef}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "end",
              paddingTop: "26px",
              marginLeft: "79px",
              marginRight: "16px",
            }}
          >
            <Pagination
              actualPage={props.currentPage}
              totalPages={props.boxContent.length}
              onPageChange={props.handlePageChange}
            />
          </Box>
        </Stack>
        <Box
          ref={divContentRef}
          className="card-scrollbars"
          sx={{
            overflow: "auto",
            maxHeight: "163px",
            margin: "0px 4px 18px 24px",
            paddingRight: "12px",
            display: "grid",
            color: "#595958",
          }}
        >
          <Box
            sx={{
              fontSize: "14px",
              textAlign: "start",
              "& h2": {
                color: "#333333",
                fontSize: "14px",
                fontWeight: "bold",
              },
              "& h3": {
                color: "#333333",
                fontSize: "14px",
                fontWeight: "bold",
              },
              "& p": {
                color: "#595958",
              },
            }}
            ref={contentRef}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default CaseStudyCardInfo
